import { SettingGroupResource, settingGroupResource } from '@witkac/kartamiejska-resources';
import { SettingGroupObjectType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł grup ustawień
 *
 * @export
 * @class SettingGroupsModule
 * @extends {EntityModule<SettingGroupObjectType, SettingGroupResource>}
 */
export class SettingGroupsModule extends EntityModule<SettingGroupObjectType, SettingGroupResource> {
  constructor() {
    super(settingGroupResource);
  }
}

export default new SettingGroupsModule();
